import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/post", {
    params,
  });

const get = (id) => authApi.get(`/post/${id}`);

const create = ({
  postTypeId,
  title,
  titleTC,
  titleSC,
  subTitle,
  subTitleTC,
  subTitleSC,
  thumbnail,
  slug,
  slugTC,
  slugSC,
  category,
  categoryTC,
  categorySC,
  subCategory,
  subCategoryTC,
  subCategorySC,
  content,
  contentTC,
  contentSC,
  css,
  video,
  videoTC,
  videoSC,
  videoOrHtml,
  metaTitle,
  metaTitleTC,
  metaTitleSC,
  metaKeyword,
  metaKeywordTC,
  metaKeywordSC,
  metaDescription,
  metaDescriptionTC,
  metaDescriptionSC,
  status,
  schedulePublishedDate,
}) =>
  authApi.post(`/post`, {
    postTypeId,
    title,
    titleTC,
    titleSC,
    subTitle,
    subTitleTC,
    subTitleSC,
    thumbnail,
    slug,
    slugTC,
    slugSC,
    category,
    categoryTC,
    categorySC,
    subCategory,
    subCategoryTC,
    subCategorySC,
    content,
    contentTC,
    contentSC,
    css,
    video,
    videoTC,
    videoSC,
    videoOrHtml,
    metaTitle,
    metaTitleTC,
    metaTitleSC,
    metaKeyword,
    metaKeywordTC,
    metaKeywordSC,
    metaDescription,
    metaDescriptionTC,
    metaDescriptionSC,
    status,
    schedulePublishedDate,
  });

const update = ({
  id,
  postTypeId,
  title,
  titleTC,
  titleSC,
  subTitle,
  subTitleTC,
  subTitleSC,
  thumbnail,
  slug,
  slugTC,
  slugSC,
  category,
  categoryTC,
  categorySC,
  subCategory,
  subCategoryTC,
  subCategorySC,
  content,
  contentTC,
  contentSC,
  css,
  video,
  videoTC,
  videoSC,
  videoOrHtml,
  metaTitle,
  metaTitleTC,
  metaTitleSC,
  metaKeyword,
  metaKeywordTC,
  metaKeywordSC,
  metaDescription,
  metaDescriptionTC,
  metaDescriptionSC,
  status,
  schedulePublishedDate,
}) =>
  authApi.put(`/post`, {
    id,
    postTypeId,
    title,
    titleTC,
    titleSC,
    subTitle,
    subTitleTC,
    subTitleSC,
    thumbnail,
    slug,
    slugTC,
    slugSC,
    category,
    categoryTC,
    categorySC,
    subCategory,
    subCategoryTC,
    subCategorySC,
    content,
    contentTC,
    contentSC,
    css,
    video,
    videoTC,
    videoSC,
    videoOrHtml,
    metaTitle,
    metaTitleTC,
    metaTitleSC,
    metaKeyword,
    metaKeywordTC,
    metaKeywordSC,
    metaDescription,
    metaDescriptionTC,
    metaDescriptionSC,
    status,
    schedulePublishedDate,
  });

const del = (id) => authApi.delete(`/post/${id}`);
  
export {
  getAll,
  get,
  create,
  update,
  del,
};
